import { FeathersModel } from '../../models/feathersModel'

import { ConfigKeys } from './ConfigKeys'

import { ConfigDefaultValues } from './ConfigDefaultValues'

export class Config extends FeathersModel {
  static serviceName = 'configs'

  name: ConfigKeys
  value: any
  allocationId?: number | null

  constructor(name: ConfigKeys, value?: any) {
    super()

    this.name = name
    this.value = value || this.getDefaultValue()
  }

  private getDefaultValue() {
    return ConfigDefaultValues[this.name] || null
  }
}
